var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUipath(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 2500,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.155 0 37.299 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#0085ca"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.454 36.845V1.155C37.454.578 37 0 36.317 0H1.292C.61 0 .155.462.155 1.155v35.69C.155 37.423.61 38 1.292 38h35.025c.682 0 1.137-.578 1.137-1.155zm-1.478-.346H1.634V1.502h34.342z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.37 30.84c5.117 0 8.415-2.889 8.415-10.396V7.739h-3.753V20.79c0 4.967-1.933 6.584-4.662 6.584s-4.435-1.617-4.435-6.584V7.854h-3.98V20.56c0 7.392 3.298 10.28 8.415 10.28zM29.835 10.857c1.365 0 2.388-.924 2.388-2.194 0-1.386-1.023-2.31-2.388-2.31s-2.388.924-2.388 2.31c0 1.27 1.024 2.194 2.388 2.194zM31.768 13.86h-3.866v16.98h3.866z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUipath);
export default __webpack_public_path__ + "static/media/uipath.28e55840c675e400b36c6cad8a4e9c09.svg";
export { ForwardRef as ReactComponent };